// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2ATzl","reverse":"style_reverse__1sfDo","checkbox":"style_checkbox__2eydl","circle":"style_circle__1GdKO","label":"style_label__ifquH"};